import React, { useState, useEffect } from "react";
import "./NewPatientRegistration.css";

const DepartmentMaster = ({ screenAction, triggerSave }) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [departments, setDepartments] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const initialFormState = {
    dept_cd: "",
    dept_name: "",
    dept_type: "",
    hod_name: "",
    contact_no: "",
    email: "",
    location: "",
    status: "Active",
    _isExisting: false
  };

  const [formData, setFormData] = useState(initialFormState);


const getNewDeptId = () => {
  const date = new Date();
  return `DEPT-${date.getFullYear()}-${Math.floor(1000 + Math.random() * 9000)}`;
};
  // --- 1. SEARCH LOGIC ---
  const searchDepartments = async (text) => {
    setSearchText(text);
    if (text.length < 2) {
      setDepartments([]);
      setShowDropdown(false);
      return;
    }
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/departments/search?q=${text}&employee_id=${user?.id}`);
      const data = await res.json();
      setDepartments(data);
      setShowDropdown(true);
    } catch (err) {
      console.error("Search error:", err);
    }
  };

  const selectDepartment = (dept) => {
    setFormData({
      ...dept,
      _isExisting: true
    });
    setSearchText(`${dept.dept_name} | ${dept.dept_cd}`);
    setShowDropdown(false);

    if (screenAction === "edit") setIsDisabled(false);
    if (screenAction === "view") setIsDisabled(true);
  };

  // --- 2. FORM ACTIONS ---
  const clearForm = async () => {
    try {
      // Auto-fetch the next ID for preview purposes
      const user = JSON.parse(localStorage.getItem("user"));
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/departments?employee_id=${user?.id}`);
      const allDepts = await res.json();
      
      
      setFormData({
        ...initialFormState,
         dept_cd: getNewDeptId()
      });
   
    } catch (err) {
      setFormData({ ...initialFormState });
    }
    setSearchText("");
    setIsDisabled(false);
  };

  useEffect(() => {
    if (triggerSave > 0 && screenAction === "save") handleSubmit();
  }, [triggerSave]);

  useEffect(() => {
    if (screenAction === "add") clearForm();
    if (screenAction === "edit") setIsDisabled(false);
    if (screenAction === "view") setIsDisabled(true);
    if (screenAction === "refresh") clearForm();
    if (screenAction === "print") printForm();
  }, [screenAction]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // --- 3. SAVE LOGIC ---
  const handleSubmit = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!formData.dept_name) return alert("Department Name is required!");

    const payload = {
      ...formData,
      created_by: user?.id
    };
delete payload._isExisting;
    const method = formData._isExisting ? "PUT" : "POST";
    const url = method === "POST" 
      ? "https://hmsapi.emedhatechnologies.com/master/api/api/departments" 
      : `https://hmsapi.emedhatechnologies.com/master/api/api/departments/${formData.dept_cd}`;

    try {
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      
      if (res.ok) {
        alert("Department Saved Successfully!");
        if (method === "POST") clearForm();
      } else {
        alert("Error saving department");
      }
    } catch (err) {
      alert("Network error while saving.");
    }
  };

  // --- 4. PRINT FORM ---
  const printForm = () => {
    const newWindow = window.open("", "", "width=900,height=700");
    const today = new Date().toLocaleDateString();

    const htmlContent = `
      <html>
        <head>
          <title>Department Master - ${formData.dept_name}</title>
          <style>
            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
            .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #2980b9; padding-bottom: 10px; margin-bottom: 20px; }
            .hospital-info h1 { margin: 0; color: #2c3e50; font-size: 24px; text-transform: uppercase; }
            .hospital-info p { margin: 2px 0; font-size: 12px; color: #7f8c8d; }
            .report-title { text-align: right; }
            .report-title h2 { margin: 0; color: #2980b9; font-size: 18px; }
            .section-header { background: #ecf0f1; padding: 8px 12px; font-weight: bold; font-size: 14px; border-left: 4px solid #2980b9; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; }
            .data-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 10px; }
            .data-item { font-size: 13px; display: flex; border-bottom: 1px dotted #ccc; padding: 6px 0; }
            .label { font-weight: 600; width: 160px; color: #555; }
            .value { flex: 1; color: #000; font-weight: 500; }
            .footer { margin-top: 50px; font-size: 10px; text-align: center; color: #95a5a6; border-top: 1px solid #eee; padding-top: 10px; }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          <div class="header">
            <div class="hospital-info">
              <h1>EMEDHA CARE HOSPITAL</h1>
              <p>Department Master Record</p>
            </div>
            <div class="report-title">
              <h2>DEPARTMENT DETAILS</h2>
              <p>Print Date: ${today}</p>
            </div>
          </div>

          <div class="section-header">Basic Information</div>
          <div class="data-grid">
            <div class="data-item"><span class="label">Department Code:</span> <span class="value">${formData.dept_cd}</span></div>
            <div class="data-item"><span class="label">Status:</span> <span class="value">${formData.status}</span></div>
            <div class="data-item"><span class="label">Department Name:</span> <span class="value">${formData.dept_name}</span></div>
            <div class="data-item"><span class="label">Department Type:</span> <span class="value">${formData.dept_type || 'N/A'}</span></div>
          </div>

          <div class="section-header">Contact & Location</div>
          <div class="data-grid">
            <div class="data-item"><span class="label">Head of Dept (HOD):</span> <span class="value">${formData.hod_name || 'N/A'}</span></div>
            <div class="data-item"><span class="label">Location/Floor:</span> <span class="value">${formData.location || 'N/A'}</span></div>
            <div class="data-item"><span class="label">Contact Number:</span> <span class="value">${formData.contact_no || 'N/A'}</span></div>
            <div class="data-item"><span class="label">Email:</span> <span class="value">${formData.email || 'N/A'}</span></div>
          </div>

          <div class="footer">
            System Generated Report - Emedha HMS
          </div>
        </body>
      </html>
    `;

    newWindow.document.write(htmlContent);
    newWindow.document.close();
  };

  return (
    <div className="registration-container fade-in">
      
      {/* SEARCH BAR (For Edit/View Modes) */}
      {(screenAction === "edit" || screenAction === "view") && (
        <div className="patient-search">
          <label>Search Department</label>
          <input
            type="text"
            value={searchText}
            placeholder="Search by ID or Name..."
            onChange={(e) => searchDepartments(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                if (departments.length === 1) selectDepartment(departments[0]);
              }
            }}
            autoFocus
          />
          {showDropdown && departments.length > 0 && (
            <div className="patient-dropdown">
              {departments.map((dept) => (
                <div key={dept.dept_cd} className="patient-item" onClick={() => selectDepartment(dept)}>
                  {dept.dept_name} | ID: {dept.dept_cd} | {dept.dept_type}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <form className="luxury-form">
        
        {/* IDENTIFICATION */}
        <div className="form-section-header">
          <h3>Department Identification</h3>
        </div>
        <div className="form-grid">
          <div className="input-box read-only">
            <label>Department Code</label>
            <input type="text" value={formData.dept_cd} readOnly placeholder="Auto Generated" />
          </div>
          <div className="input-box">
            <label>Department Name <span style={{color:'red'}}>*</span></label>
            <input type="text" name="dept_name" value={formData.dept_name} onChange={handleChange} disabled={isDisabled} placeholder="e.g., Cardiology" />
          </div>
          <div className="input-box">
            <label>Department Type</label>
            <select name="dept_type" value={formData.dept_type} onChange={handleChange} disabled={isDisabled}>
              <option value="">Select Type</option>
              <option value="Clinical">Clinical</option>
              <option value="Administrative">Administrative</option>
              <option value="Operational">Operations & Support</option>
              <option value="Diagnostics">Diagnostics / Lab</option>
            </select>
          </div>
          <div className="input-box">
            <label>Status</label>
            <select name="status" value={formData.status} onChange={handleChange} disabled={isDisabled}>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        {/* DETAILS & CONTACT */}
        <div className="form-section-header">
          <h3>Details & Contact</h3>
        </div>
        <div className="form-grid">
          <div className="input-box">
            <label>Head of Department (HOD)</label>
            <input type="text" name="hod_name" value={formData.hod_name} onChange={handleChange} disabled={isDisabled} placeholder="Name of HOD" />
          </div>
          <div className="input-box">
            <label>Location / Floor</label>
            <input type="text" name="location" value={formData.location} onChange={handleChange} disabled={isDisabled} placeholder="e.g., 2nd Floor, Block A" />
          </div>
          <div className="input-box">
            <label>Contact Number</label>
            <input type="text" name="contact_no" value={formData.contact_no} onChange={handleChange} disabled={isDisabled} placeholder="Ext or Phone No." />
          </div>
          <div className="input-box">
            <label>Email Address</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} disabled={isDisabled} placeholder="dept@hospital.com" />
          </div>
        </div>

      </form>
    </div>
  );
};

export default DepartmentMaster;